const theme = {
  colors: {
    manila: '#FAF3E8',
    manilaDark: '#F0E8D8',
    manilaLight: '#FDF9F0',
    paper: '#FFFEF9',
    ink: '#5A5247',
    brown: '#C4B5A0',
    brownDark: '#A89B88',
    red: '#D4847C',
    redacted: '#3A3A3A',
  },
  fonts: {
    body: "'Special Elite', monospace",
    mono: "'Courier New', monospace",
  },
};

export default theme;
